export const _getObjectsSection = (type, computedValues, displayValues) => {
  switch (type) {
    case "ap":
      return {
        "Absences Incurred": computedValues.absencesIncurred,
        "Lates/Undertime Incurred": computedValues.latesUtIncurred,
        Overpayment: displayValues.overpayment,
        "Flag Raising": displayValues.flagRaising,
        "Tax Withheld": displayValues.tax,
      };
    case "jo":
      return {
        "Absences Incurred(Days)": displayValues.absencesDays,
        "Absences Incurred(Late/Undertime)": displayValues.absencesMins,
        Overpayment: displayValues.overpayment,
        "Flag Raising": displayValues.flagRaising,
        "Tax Withheld": displayValues.tax,
      };
    case "backpay":
      return {
        "Absences Incurred(Days)": computedValues.absencesIncurred,
        "Absences Incurred(Late/Undertime)": computedValues.latesUtIncurred,
        Overpayment: displayValues.overpayment,
        "Flag Raising": displayValues.flagRaising,
        "Tax Withheld": displayValues.tax,
      };
    default:
      return {};
  }
};
